
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"11","height":"8","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8.347 8H.95C.426 8 0 7.546 0 6.985v-5.97C0 .455.426 0 .951 0h7.396c.332 0 .64.185.813.488l1.702 2.984c.185.325.185.731 0 1.056L9.16 7.512A.94.94 0 018.347 8z","fill":"#262626"}})])
          )
        }
      }
    